'use strict';

import Component from 'generic.basecomponent';
import app from 'app-instance';
import infoWindowTemplate from '../html/infoWindowTemplate.hbs';

export default class Map extends Component {
    constructor(el) {
        super(el);

        this.map = this.container.querySelector(this.constructor._settings.mapSelector);
        if (!this.map) {
            return;
        }
        this.mapId = this.map.getAttribute('data-map-id');

        this.markers = [];
        this.centeredMarkerIndex = null;
        this.markerParent = this.container.querySelector(this.constructor._settings.markersSelector);
        this.isFullScreen = false;
        this.scriptPromise = this.constructor.loadScript();
        this.scriptPromise.then(this.init.bind(this));
        this.infoWindow = null;
    }

    init() {
        this.initMap();
        this.initMarkers();
        this.centerMarkers();
        this.initFullScreenBtn();

        app.addListener('resize:finished', this.resize.bind(this));
        if (this.mapId) {
            app.addListener(`map:${this.mapId}`, (index) => {
                this.centerMarkerByIndex(index);
            })
        }
    }

    initMap() {
        this.zoom = parseInt(this.map.getAttribute('data-zoom')) || 0;
        this.gmap = new google.maps.Map(this.map, {
            center: new google.maps.LatLng(
                parseFloat(this.map.getAttribute('data-lat')) || 0,
                parseFloat(this.map.getAttribute('data-lon')) || 0
            ),
            zoom: this.zoom,
            scrollwheel: true
        });

        google.maps.event.addListener(this.gmap, 'click', () => {
            if (this.infoWindow !== null) {
                this.infoWindow.close();
                this.infoWindow = null;
            }
        });
    }

    centerMarkerByIndex(index) {
        this.centeredMarkerIndex = index;
        this.centerSingleMarker();
    }

    centerSingleMarker() {
        let index = this.centeredMarkerIndex || 0;
        this.gmap.setCenter(this.markers[index].marker.getPosition());
        this.gmap.setZoom(this.zoom);
    }

    centerMarkers() {
        if (this.markers.length === 1 || this.centeredMarkerIndex !== null) {
            this.centerSingleMarker();
        } else {
            this.centerMultipleMarkers();
        }
    }

    centerMultipleMarkers() {
        let bounds = new google.maps.LatLngBounds();
        bounds = this.markers.reduce((bounds, element) => {
            return bounds.extend(element.marker.getPosition());
        }, bounds);
        this.gmap.fitBounds(bounds);
    }

    resize() {
        this.centerMarkers();
    }

    initMarkers() {
        if (!this.markerParent) {
            return;
        }
        let markerDivs = Array.prototype.slice.call(this.markerParent.childNodes).filter((child) => {
            return child.nodeType === Node.ELEMENT_NODE;
        });
        let markers = [];
        markerDivs.forEach((markerDiv) => {
            let lat = markerDiv.getAttribute('data-lat'),
                lon = markerDiv.getAttribute('data-lon'),
                id = markerDiv.getAttribute('data-id'),
                title = markerDiv.getAttribute('data-title') || '',
                text = markerDiv.getAttribute('data-text') || '';

            markers.push({lat, lon, id, title, text});
        });

        this.setMarkers(markers);
    }

    setMarkers(markers) {
        let goldStar = {
            path: `M145.2,0C64,1.1-1,67.8,0,149.1C0,298.1,145.2,477,145.2,477s145.2-178.9,145.2-327.9
                C291.4,67.8,226.4,1.1,145.2,0z M145.2,240.4c-50.4,1.3-92.3-38.5-93.5-88.9s38.5-92.3,88.9-93.5c50.4-1.3,92.3,38.5,93.5,88.9
                c0,0.8,0,1.5,0,2.3C234.7,198.9,194.9,239.7,145.2,240.4z M88.9,149.1c0.8-31.1,26.6-55.6,57.7-54.8c31.1,0.8,55.6,26.6,54.8,57.7
                c-0.8,30.5-25.8,54.9-56.3,54.9C113.7,206.4,88.5,180.5,88.9,149.1L88.9,149.1z`,
            fillColor: 'black',
            fillOpacity: 1,
            scale: 0.05,
        };

        this.markers.forEach((marker) => {
            marker.marker.setMap(null);
        });

        this.markers = [];

        markers.forEach((marker) => {

            let gmarker = new google.maps.Marker({
                position: new google.maps.LatLng(marker.lat, marker.lon),
                map: this.gmap,
                animation: google.maps.Animation.DROP,
                icon: goldStar,
                id: marker.id
            });

            gmarker.addListener('click', () => {
                this.openInfoWindow(gmarker, marker)
            });

            this.markers.push({
                marker: gmarker
            });
        });
    }

    initFullScreenBtn() {
        const onClick = (e) => {
            e.preventDefault();
            this.toggleMapSize();
        };
        let buttons = Array.prototype.slice.call(this.container.querySelectorAll(this.constructor._settings.fullScreenBtnSelector));
        buttons.forEach((button) => {
            button.addEventListener('click', onClick);
        })
    }

    toggleMapSize() {
        this[this.isFullScreen ? "fullScreenOff" : "fullScreenOn"]();
    }

    fullScreenOn() {
        this.isFullScreen = true;
        this.container.classList.add(this.constructor.settings.fullscreenClass);
        document.body.style.overflow = 'hidden';
    }

    fullScreenOff() {
        this.isFullScreen = true;
        this.container.classList.remove(this.constructor.settings.fullscreenClass);
        document.body.style.overflow = '';
    }

    openInfoWindow(gmarker, data) {
        if(Map.isMarkerCanOpenInfoWindow(data)){
            if (!this.infoWindow) {
                this.infoWindow = new google.maps.InfoWindow({maxWidth: 200});
            }
            this.infoWindow.setContent(infoWindowTemplate(data));
            this.infoWindow.open(this.gmap, gmarker);
        }
    }

    static loadScript() {
        let scriptPromise = new Promise((resolve, reject) => {

            let success = () => resolve(),
                error = () => reject(),
                script = document.createElement("script");

            script.type = "text/javascript";
            script.async = "async";
            script.onerror = error;

            window.initGoogleMaps = success;
            document.head.appendChild(script);

            script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAhMtmMQPmDEX37wZi8BNZ2qn6wHMLcmaQ&callback=initGoogleMaps';
        });

        Map.loadScript = () => {
            return scriptPromise;
        };

        return Map.loadScript();
    };

    static isMarkerCanOpenInfoWindow(data) {
        return data.title !== ''
    }
}


Map.id = 0;
Map._settings = {
    fullscreenClass: 'fullscreened',
    mapSelector: '.js-google-map',
    markersSelector: '.js-google-map-markers',
    fullScreenBtnSelector: '.js-toggle-map-full-screen'
};



// WEBPACK FOOTER //
// ./app/components/map/js/generic.map.js